import { render } from "./NeedChangePassword.vue?vue&type=template&id=6523ab0b&scoped=true"
import script from "./NeedChangePassword.vue?vue&type=script&lang=js"
export * from "./NeedChangePassword.vue?vue&type=script&lang=js"

import "./NeedChangePassword.vue?vue&type=style&index=0&id=6523ab0b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6523ab0b"]])

export default __exports__